(() => {
  document.querySelectorAll('[data-pm3d]:not([data-pm3d-ready])').forEach(root => {
    root.dataset.pm3dReady = 'true';
    const dialog = root.querySelector('dialog');
    const status = root.querySelector('[role="status"]');
    const opener = root.querySelector('[data-pm3d-open]');
    let viewer;
    const reset = () => {
      viewer.cameraTarget = 'auto auto auto';
      viewer.cameraOrbit = '35deg 65deg auto';
      viewer.fieldOfView = '30deg';
    };
    opener.addEventListener('click', async () => {
      dialog.showModal();
      if (viewer) return;
      try {
        window.permiu3DModule ||= import(root.dataset.moduleUrl);
        await window.permiu3DModule;
        if (!dialog.open) return;
        viewer = document.createElement('model-viewer');
        viewer.setAttribute('alt', root.dataset.modelTitle + ' interactive 3D model');
        viewer.setAttribute('camera-controls', '');
        viewer.setAttribute('touch-action', 'none');
        viewer.setAttribute('shadow-intensity', '0.8');
        viewer.setAttribute('shadow-softness', '1');
        viewer.setAttribute('exposure', '1');
        viewer.setAttribute('camera-orbit', '35deg 65deg auto');
        viewer.setAttribute('interaction-prompt', 'none');
        viewer.setAttribute('min-camera-orbit', 'auto 5deg 25%');
        viewer.setAttribute('max-camera-orbit', 'auto 175deg 250%');
        viewer.addEventListener('load', () => {
          status.textContent = '3D model ready. Drag to rotate, pan, or zoom.';
          status.dataset.loaded = 'true';
        });
        viewer.addEventListener('error', () => {
          delete status.dataset.loaded;
          status.textContent = 'The 3D model could not load. Please close this view and refresh to try again.';
        });
        viewer.src = root.dataset.modelUrl;
        root.querySelector('.pm3d-stage').append(viewer);
      } catch (error) {
        status.textContent = 'The 3D viewer could not load. Please refresh to try again.';
      }
    });
    root.querySelector('[data-pm3d-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      viewer?.remove();
      viewer = null;
      delete status.dataset.loaded;
      status.textContent = 'Loading your 3D view…';
      opener.focus();
    });
    dialog.addEventListener('click', event => {
      const r = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
    });
    root.querySelectorAll('[data-pm3d-action]').forEach(button => button.addEventListener('click', () => {
      if (!viewer?.loaded) return;
      const action = button.dataset.pm3dAction;
      if (action === 'reset') return reset();
      const orbit = viewer.getCameraOrbit();
      const theta = orbit.theta + (action === 'left' ? -Math.PI / 6 : action === 'right' ? Math.PI / 6 : 0);
      const radius = orbit.radius * (action === 'in' ? 0.8 : action === 'out' ? 1.25 : 1);
      viewer.cameraOrbit = `${theta}rad ${orbit.phi}rad ${radius}m`;
    }));
  });
})();
